import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const ITEMS = [
  "PERUMAHAN TYPE 36",
  "KONSEP CLUSTER",
  "HUNIAN UNTUK KELUARGA",
  "LINGKUNGAN TERTATA",
  "DESAIN MODERN",
  "RUANG TUMBUH KELUARGA",
];

export default function EditorialMarquee() {
  return (
    <div className="border-y border-slate-100 bg-brand-mist py-5" data-testid="editorial-marquee">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-6 flex items-center gap-6">
            <span className="font-display text-lg font-bold uppercase tracking-[0.2em] text-brand-dark/70">
              {item}
            </span>
            <Asterisk className="h-5 w-5 text-brand" aria-hidden="true" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
